

















































import SelectVariable from "@/components/selectVariable.vue";
import useTemplates from "@/composables/v3/useTemplates";
import useUpload from "@/composables/v3/useUpload";
import ToastificationContent from "@/layouts/components/toastification/toastificationContent.vue";
import axios from "@/libs/axios";
// @ts-ignore
import i18n from "@/libs/i18n";
// @ts-ignore
import { required } from "@validations";
import { computed, defineComponent, ref } from "@vue/composition-api";
import {
    BButton,
    BCard,
    BCardBody,
    BCardText,
    BCol,
    BForm,
    BFormFile,
    BFormGroup,
    BFormInput,
    BRow,
} from "bootstrap-vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { useToast } from "vue-toastification/composition";

export default defineComponent({
    components: {
        SelectVariable,
        ValidationProvider,
        ValidationObserver,
        required,
        BCardText,
        BFormInput,
        BFormGroup,
        BForm,
        BFormFile,
        BRow,
        BCol,
        BButton,
        BCard,
        BCardBody,
    },
    setup() {
        const toast = useToast();

        const { fetchVariablesFromContent, variablesToIndex, availableVariables, selectedTemplate, resetTemplate } =
            useTemplates();
        const selectedTemplateString = ref("");

        // @ts-ignore
        selectedTemplate.value.indexed = variablesToIndex(selectedTemplate.value.content);

        const submit = () => {
            axios
                .patch(`templates/${selectedTemplate.value.id}`, {
                    content: selectedTemplate.value.content,
                })
                .then(() => {
                    toast({
                        component: ToastificationContent,
                        props: {
                            title: i18n.t("entities.templates.approved-templates"),
                            text: i18n.t("toast.update.success", { entity: i18n.t("entities.templates.template") }),
                            icon: "check",
                            variant: "success",
                        },
                    });

                    resetTemplate();
                })
                .catch(() =>
                    toast({
                        component: ToastificationContent,
                        props: {
                            title: i18n.t("entities.templates.approved-templates"),
                            text: i18n.t("toast.update.error", { entity: i18n.t("entities.templates.template") }),
                            icon: "times",
                            variant: "danger",
                        },
                    })
                );
        };

        const setVariableDropdowns = () => {
            const variables = fetchVariablesFromContent(selectedTemplate.value.content);
            selectedTemplateString.value = selectedTemplate.value.content;
        };

        const messageParts = computed({
            get: () => {
                const regex = /{{[^}]+}}/g;

                let match;
                let previousIndex = 0;
                const messageParts = [];

                while ((match = regex.exec(selectedTemplate.value.content)) !== null) {
                    messageParts.push({
                        message: selectedTemplate.value.content.substring(previousIndex, match.index),
                        variable: match[0],
                    });

                    previousIndex = match.index + match[0].length;
                }

                messageParts.push({
                    message: selectedTemplate.value.content.substring(previousIndex),
                });

                return messageParts;
            },
            set: (value) => {
                selectedTemplate.value.content = value.reduce(
                    (message, variable) => message + variable.message + (variable.variable ?? ""),
                    ""
                );
            },
        });

        const setVariable = (messagePart, variable) => {
            messagePart.variable = variable;
            messageParts.value = [...messageParts.value];
        };

        const { getAllowedFileTypes } = useUpload();
        setVariableDropdowns();
        // @ts-ignore
        const allowedFileTypes = computed(() => getAllowedFileTypes(selectedTemplate.value.mediaType, "whatsapp"));

        const openFilePrompt = () => {
            document.getElementById("file").click();
        };

        return {
            setVariable,
            messageParts,
            selectedTemplateString,
            fetchVariablesFromContent,
            submit,
            resetTemplate,

            allowedFileTypes,
            openFilePrompt,
            selectedTemplate,
        };
    },
});
